export default {
    bind: function (target, binding, vnode, oldvnode) {
        if (!binding.value) {
            return
        }

        const detail = {
            target: target,
            type: binding.arg || binding.value?.type?.toLowerCase(),
            modifiers: binding.modifiers,
            value: binding.value,
        }

        let timeout = null

        const openPopover = e => {
            if (timeout) {
                clearTimeout(timeout)
            }

            timeout = setTimeout(
                () =>
                    vnode.context?.$store?.dispatch(
                        'openPopover',
                        Object.assign(detail, { clientX: e.clientX, clientY: e.clientY })
                    ),
                250
            )
        }

        const closePopover = () => {
            if (timeout) {
                clearTimeout(timeout)
            }

            timeout = setTimeout(() => vnode.context?.$store?.dispatch('closePopover', detail), 250)
        }

        target.addEventListener('mouseenter', openPopover)
        target.addEventListener('mouseleave', closePopover)

        target.$popoverUnbind = () => {
            target.removeEventListener('mouseenter', openPopover)
            target.removeEventListener('mouseleave', closePopover)

            if (timeout) {
                clearTimeout(timeout)
            }
        }
    },
    unbind: function (target) {
        if (target.$popoverUnbind) {
            target.$popoverUnbind()
        }
    },
}
